import { supabase } from '../lib/supabase';
import { invokeAuthed } from './functionAuth';

const FALLBACK = 'Ask AI is unavailable right now. You can still add a follow-up manually.';
const NOT_DEPLOYED = 'Ask AI has not been deployed to this project yet. You can still add a follow-up manually.';
const NETWORK = 'Could not reach Ask AI. It may not be deployed yet, or your connection dropped. You can still add a follow-up manually.';
const BOOT = 'Ask AI is deployed but failed to start. Redeploy the followups-ai function. You can still add a follow-up manually.';
const CONTACT_FIELDS = 'id, full_name, company, email';

// Only prepares a draft. Nothing is saved until the user approves it.
export const followUpAiService = {
  prepare: async (text, mentions = []) => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    const { data, error } = await invokeAuthed('followups-ai', { text, timezone, mentions });
    if (error) {
      let message = error.context?.status === 404 ? NOT_DEPLOYED : FALLBACK;
      if (!error.context?.status) message = NETWORK;
      try {
        const payload = await error.context.json();
        if (payload?.error) message = payload.error;
        else if (payload?.code === 'BOOT_ERROR') message = BOOT;
      } catch (e) {
        // Keep the message chosen above.
      }
      throw new Error(message);
    }
    if (!data || data.error) throw new Error(data?.error || FALLBACK);
    return data;
  },

  // The user's own contacts (row level security limits this to their records).
  listContacts: async () => {
    const { data, error } = await supabase
      .from('contacts')
      .select(CONTACT_FIELDS)
      .order('full_name', { ascending: true })
      .limit(1000);
    if (error) throw new Error('Could not load your contacts.');
    return (data || []).filter((c) => c.full_name);
  },

  // Only called after the user explicitly chooses "Create contact".
  createContact: async (userId, fullName) => {
    const name = (fullName || '').trim().slice(0, 300);
    if (!name) throw new Error('Enter a name for the new contact.');
    const { data, error } = await supabase
      .from('contacts')
      .insert({ owner_id: userId, full_name: name })
      .select(CONTACT_FIELDS)
      .single();
    if (error) throw new Error('Could not create the contact. Please try again.');
    return data;
  }
};